import { Typography, styled } from "@mui/material";
import { NavLink } from "react-router-dom";
import { getAccessibleTextColor } from "../BrandingProvider/mealTrackThemeConfigurations";
/**
 * The TypographyNavLink component is a styled component that extends the MUI Typography component.
 * It is used to create a Typography component that is also a React-Router NavLink.
 * @default typography-variant: "h4"
 */
export const TypographyNavLink = styled(Typography)(({ theme }) => {
    var _a, _b;
    const headerTextColor = ((_a = theme.palette.header) === null || _a === void 0 ? void 0 : _a.textColor) || theme.palette.common.black;
    const headerBgColor = ((_b = theme.palette.header) === null || _b === void 0 ? void 0 : _b.backgroundColor) || theme.palette.common.white;
    const headerNavTextColor = getAccessibleTextColor(theme, headerTextColor, headerBgColor);
    return {
        textDecoration: "none",
        color: theme.palette.grey[`A700`],
        "&.active": {
            textDecoration: "underline",
            textDecorationThickness: "2px",
            textUnderlinePosition: "under",
            textUnderlineOffset: "2px",
            textDecorationColor: getAccessibleTextColor(theme, theme.palette.primary.main, headerBgColor),
            color: headerNavTextColor,
        },
        "&.is-logged-out-nav": {
            color: headerNavTextColor,
        },
    };
});
/**
 * Sets the default props. DO NOT CHANGE.
 * If additional customizations are required, creating a new styled component is likely the better approach.
 */
TypographyNavLink.defaultProps = {
    component: NavLink,
    variant: "h4", // The default variant for the typography nav link component.
};
